module.exports = __webpack_public_path__ + "img/product2_007FFF_age.b2e80e51.png";